<svg class="spinner" [attr.x]="0" [attr.y]="0" [attr.viewBox]="'0 0 40 40'">
    <circle cx="20" cy="20" r="18"></circle>
</svg>
